// @flow

/**
 * AI Prompt Management Constants
 * Generic configuration values for conversational AI chat interface
 */

export const DEFAULT_MAX_PROMPT_CHARS = 1000;
export const DEFAULT_AUTO_SCROLL_THRESHOLD_PX = 10;
export const DEFAULT_SCROLL_DEBOUNCE_MS = 50;
export const DEFAULT_PAUSE_DURATION_MS = 1000;

/**
 * Scroll modes for the orchestrator state machine
 */
export const SCROLL_MODE = {
  AUTO: 'auto',      // Auto-scroll enabled, following streaming content
  MANUAL: 'manual',  // User has taken manual control, auto-scroll disabled
  PAUSED: 'paused',  // Temporarily paused for user action (e.g., comment input reveal)
};

/**
 * Scroll request priorities
 * Higher number = higher priority
 */
export const SCROLL_PRIORITY = {
  LOW: 1,      // Streaming auto-scroll (can be interrupted)
  MEDIUM: 2,   // Component-initiated scroll (feedback comment)
  HIGH: 3,     // Manual user scroll (disables auto)
};

/**
 * Default tag transformers applied before PDF/DOCX export.
 * Each entry maps a custom HTML tag to its markdown replacement.
 */
export const DEFAULT_EXPORT_TAG_TRANSFORMERS = [
  { tagName: 'prompt', transform: (content: string) => `- ${content}` },
  { tagName: 'data-display', transform: () => '' },
  { tagName: 'answer-summary', transform: (content: string) => content },
  { tagName: 'answer-detail', transform: (content: string) => content },
];
